import { render } from "./InvoiceFormFields.vue?vue&type=template&id=3ddb676a"
import script from "./InvoiceFormFields.vue?vue&type=script&lang=js"
export * from "./InvoiceFormFields.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__